/** Field used to order the courses listed under a topic. */
export enum CourseSortField {
    CourseName,
    CourseId,
}
